export const DEFAULT_MAP_CENTER_POSITION = {
  LAT: 48.43919727139413,
  LNG: 9.743455501696545
};

export const GEOFENCE_ACTION = {
  VIEW: 'VIEW',
  INITIAL_GEOFENCE: 'INITIAL_GEOFENCE',
  EDIT: 'EDIT',
  DISCARD: 'DISCARD',
  SAVE: 'SAVE'
};
